import { type RouteRecordRaw } from "vue-router";

export const protectedRoutes: RouteRecordRaw[] = [
  {
    path: "anpa",
    name: "anpa",
    component: () => import("./pages/AnpaSettings.vue"),
    meta: { title: "menu.anpa", requiresAuth: true, requiresStaff: true },
  },
];
